export const namespaced = true;

export const state = {
  pendingTrips: [],
  profile: {}, //logged in user profile
  currentTravellerProfile: {}, //profile for designated traveler
  otherProfiles: {},
  travellers: {
    tripType: "business",
    bookFor: "user",
    others: [], //deprecated
    set: true,
  },
  unaccompaniedMinorAirlineDetails: [],
};

export const mutations = {
  //set active user profile
  ADD_PROFILE(state, payload) {
    state.profile = payload;
  },
  //set traveller profile
  SET_TRAVELLER_PROFILE(state, payload) {
    state.currentTravellerProfile = payload;
  },
  ADD_OTHER_PROFILE(state, payload) {
    let id = payload[0];
    let profile = payload[1];
    if (!state.otherProfiles[id]) {
      state.otherProfiles[id] = profile;
    }
  },
  EDIT_TRAVELLERS(state, payload) {
    state.travellers = payload;
  },
  UNACCOMPANIED_MINOR_AIRLINE_DETAILS(state, payload) {
    state.unaccompaniedMinorAirlineDetails = payload;
  },
  ADD_PAYMENT(state, payload) {
    state.currentTravellerProfile.paymentMethods.push(payload);
    
  },
};

export const actions = {
  addPendingTrips(context) {
    context.commit(
      "bookTravel/CHANGE_MAIN_RESULT",
      {
        flight: {},
        car: {},
        hotel: {},
      },
      { root: true }
    );
  },
  //set active user profile
  addProfile(context, payload) {
    context.commit("ADD_PROFILE", payload);
  },
  addPayment(context, payload) {
    console.log(payload);

    if (context.rootState.meetings.meetingInfo) {
      context.commit("meetings/ADD_PAYMENT_TO_MEETING_CONTACT", payload, {root: true});
    } else {
      context.commit("ADD_PAYMENT", payload);
    }
    
  },
  unaccompaniedMinorAirlineDetails(context, payload) {
    context.commit("UNACCOMPANIED_MINOR_AIRLINE_DETAILS", payload);
  },
  addMeetingContactToProfile(context) {
    if (context.rootState.meetings.meetingInfo) {
      let contact = context.rootState.meetings.meetingInfo.contact;
      // Override the traveler's regular travel policy
      // with the meeting specific travel policy
      contact.travelPolicyId =
        context.rootState.meetings.meetingInfo.travelPolicyId;
      contact.travelPolicy =
        context.rootState.meetings.meetingInfo.travelPolicy;
      context.commit("SET_TRAVELLER_PROFILE", contact);
      console.log('done loading profile from meeting contact.')
    } 
  },
};

export const getters = {

  getCurrentTravellerProfile(state, getters, rootState){
    return state.currentTravellerProfile;
  },

  /*
  getCurrentTravellerProfile(state, getters, rootState) {
    if (rootState.meetings.meetingInfo) {
      let contact = rootState.meetings.meetingInfo.contact;
      // Override the traveler's regular travel policy
      // with the meeting specific travel policy
      contact.travelPolicyId = rootState.meetings.meetingInfo.travelPolicyId;
      contact.travelPolicy = rootState.meetings.meetingInfo.travelPolicy;
      return contact;
    } else {
      let profile = {};
      if (state.travellers.set) {
        if (state.travellers.bookFor == "user") {
          profile = state.profile;
        } else {
          profile = state.otherProfiles[state.travellers.others[0][0].id];
        }
      }
      return profile;
    }
  },
  */

  getTravellers(state) {
    return state.travellers;
  },
};
